import React, { useContext, useState, useEffect } from 'react';
import Card from 'antd/lib/card';
import Button from 'antd/lib/button';
import { GlobalStateContext } from '../context/GlobalStateProvider';
import {navigate, navigateToHome} from '../navigation/navigationHistory';
import {ConfigContext} from './PortalApp';
import {Icon} from "antd";

const BodyText = ({ bodyText, quoteNumber,phoneNumber }) => {
  return bodyText.map(({ contactUsText }, index) => (
    <div key={index} style={{ paddingTop: '8px', paddingBottom: '8px' }}>
      <p>{contactUsText.replace(/<quoteNumber>/g, quoteNumber).replace(/<companyPhoneNumber>/g, phoneNumber)}</p>
    </div>
  ));
};

export const NotificationPage = ({ cardType, noticeText, headerText, bodyText }) => {
  const {  isDesktop, isMobile, isTablet } = useContext(GlobalStateContext);
  const config = useContext(ConfigContext);
  const [isLoading, setIsLoading] = useState(false);
  const { data: quoteNumber } = history.state;
  const companyPhoneNumber = config.branding.companyPhoneNumber ? config.branding.companyPhoneNumber : '<companyPhoneNumber>';
  const parsedNoticeText = noticeText ? noticeText.replace(/<quoteNumber>/g, quoteNumber).replace(/<companyPhoneNumber>/g, companyPhoneNumber) : '';

  useEffect(() => {
      updateBranding(sessionStorage.getItem('b1_sales_influencer_id') == config.branding.influencer1.id);
  });

  const handleClose = () => {
    setIsLoading(true);
    setTimeout(() => {
      navigateToHome();
      setIsLoading(false);
    }, 1000);
  };

  const getCardWidth = () => {
    if (isDesktop) {
      return '70%';
    }
    if (isTablet) {
      return '90%';
    }
  };

  const returnToHome = () => {
    navigateToHome();
  };

  const styles = {
    cardContainer: {
      width: getCardWidth(),
      margin: 'auto',
      paddingBottom: '2em',
      paddingRight: !isDesktop ? '1em' : '10em',
      paddingLeft: !isDesktop ? '1em' : '10em',
    },
    titleHeader: {
      display: 'flex',
      fontSize: isMobile ? '17px' : '28px',
      fontWeight: 'bold',
      marginBottom: '1em',
    },
  };

  //TODO each of the cards defined below can be refactored as the styling and html structure is very similar/the same with minor differences such as close button, home link, notification banner
  const quoteReviewCard = () =>{
    return (
        <Card style={styles.cardContainer}>
          <div style={{ padding: '8px' }}>
            <h2 style={styles.titleHeader}>{headerText}</h2>
            <BodyText bodyText={bodyText} quoteNumber={quoteNumber} phoneNumber={companyPhoneNumber} />
            <div className='btn-group'>
              <Button
                  loading={isLoading}
                  type="primary"
                  onClick={handleClose}
              >
                Close
              </Button>
            </div>
          </div>
        </Card>
    );
  }

  const referAgentSuccessCard = () => {
    return (
        <Card style={styles.cardContainer}>
          <div className='agent-success-notification'>
            <Icon
                type='info-circle'
                style={{ fontSize: '24px', marginRight: '8px' }}
            />
            <span style={{ fontWeight: 'normal' }}>
            {'  '}
              {parsedNoticeText}
              .
          </span>
          </div>
          <span style={styles.titleHeader}>{headerText}</span>
          <BodyText bodyText={bodyText} quoteNumber={quoteNumber} phoneNumber={companyPhoneNumber} />
           <div className='btn-group'>
            <Button
                type='primary'
                onClick={returnToHome}
            >
              Close
            </Button>
          </div>
        </Card>
    );

  }

  const referAgentFailureCard = () => {
    return (
        <Card style={styles.cardContainer}>
          <div className='agent-error-notification'>
            <Icon
                type='info-circle'
                style={{ fontSize: '24px', marginRight: '8px' }}
            />
            <span style={{ fontWeight: 'bold' }}>
          Please contact us.
          <span style={{ fontWeight: 'normal' }}>
            {' '}
            {parsedNoticeText}
          </span>
        </span>
          </div>
          <span style={styles.titleHeader}>Please contact us.</span>
          <BodyText bodyText={bodyText} quoteNumber={quoteNumber} phoneNumber={companyPhoneNumber} />
          <div
              style={{ display: 'flex', flexDirection: 'column', marginTop: '1em' }}
          >
            <a onClick={()=>navigateToHome()} className='return-home-link'>
              Return to Home Page
            </a>
            <span>
          where you can start a new quote, retrieve an existing quote or contact
          us for assistance.
        </span>
          </div>
        </Card>
    );
  }

  const declineConsentCard = () => {
    const heading = (headerText ? headerText : 'Your quote cannot be processed.');
    const quoteId = (quoteNumber ? quoteNumber : '');
    return (
        <Card style={styles.cardContainer}>
          <div className='warning-notification'>
            <Icon
                type='info-circle'
                style={{fontSize: '24px', marginRight: '8px'}}
            />
            <span style={{fontWeight: 'bold'}}>
          Quote cannot be processed.{' '}
              <span style={{fontWeight: 'normal'}}>
            {' '}
                {parsedNoticeText}
              </span>
            </span>
          </div>
          <span style={styles.titleHeader}>
        {heading}
      </span>
          <BodyText bodyText={bodyText} quoteNumber={quoteId} phoneNumber={companyPhoneNumber} />
          <div
              style={{ display: 'flex', flexDirection: 'column', marginTop: '1em' }}
          >
            <a onClick={()=>navigateToHome()} className='return-home-link'>
              Return to Home Page
            </a>
            <span>
          where you can start a new quote, retrieve an existing quote or contact
          us for assistance.
        </span>
          </div>
        </Card>
    );
  }

  const getCardType = (cardType) => {
    switch ((cardType)) {
      case 'quoteReview':
        return quoteReviewCard();
      case 'agentError':
        return referAgentFailureCard();
      case 'agentSuccess':
        return referAgentSuccessCard();
      case 'declineConsent':
      case 'maintenance':
        return declineConsentCard();
      default:
        //TODO create a generic error page
    }
  }

  const card = getCardType(cardType);

  return card;



};

function updateBranding(influencerChanges){
    if (influencerChanges) {
        const primaryButtons = document.querySelectorAll('.ant-btn-primary');
        primaryButtons.forEach(element => {
          element.classList.add('cobranded-primary-button');
          element.classList.remove('ant-btn-primary');
        });
        const secondaryButtons = document.querySelectorAll('.secondary-button');
        secondaryButtons.forEach(element => {
          element.classList.add('cobranded-secondary-button');
          element.classList.remove('secondary-button');
        });
        const linkButtons = document.querySelectorAll('.ant-btn-link');
        linkButtons.forEach(element => {
          element.classList.add('cobranded-button-link');
          element.classList.remove('ant-btn-link');
        });
    }
}